import Vue from 'vue'
import VuePikaday from '@enrian/vue-pikaday';
import BootstrapVue from 'bootstrap-vue'
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import VeeValidate, {Validator} from "vee-validate";
import pt_BR from 'vee-validate/dist/locale/pt_BR.js'
import Icon from "@/app/components/Icon.vue";
import Notifications from 'vue-notification'
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import VueMq from 'vue-mq'
import Vuebar from '@/app/store/plugins/vuebar.js';
import VTooltip from 'v-tooltip'
import "@enrian/vue-pikaday/dist/vue-pikaday.min.css";

import AppDesktop from './App.vue';
import AppMobile from './AppMobile.vue';
import { isMobile } from 'mobile-device-detect';
import router from './router';

var App = isMobile ? AppMobile : AppDesktop;

Vue.config.productionTip = false

// Registrar am4charts
am4core.addLicense("CH217405995");
am4core.useTheme(am4themes_animated);
// am4core.options.queue = true;
// am4core.options.onlyShowOnViewport = true;
am4core.options.minPolylineStep = 15;

Vue.use(VuePikaday);
Vue.use(BootstrapVue);
Vue.use(SweetModal);
Vue.use(VeeValidate, { fieldsBagName: 'veeValidateFields' });
Vue.use(Notifications);
Vue.use(Vuebar);
Vue.use(VTooltip)
Vue.component('icon', Icon);

// Install and Activate the Portuguese locale.
VeeValidate.Validator.localize('pt_BR', pt_BR);
Validator.extend("requiredRadio", {
    getMessage: `Este campo é obrigatório.`,
    validate: (value) => { 
        return value > 0
    }
})

Vue.use(VueMq, {
  breakpoints: {
    mobile: 986,
    desktop: Infinity, 
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

Vue.component('icon', Icon);

// Gerenciador de erros genéricos global
Vue.config.errorHandler = function (err, vm, info) {
  if (vm == null || !vm._isVue) {
      router.push({ name: "Erro", params: { mensagem: err }});
  } else {
      console.log("Erro identificado:", err);
      // console.log("vm:", vm);
      console.log("info:", info);
  }
}

// Font Awesome
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';